import { render, staticRenderFns } from "./chapterExam.vue?vue&type=template&id=cf647c08&scoped=true"
import script from "./chapterExam.vue?vue&type=script&lang=js"
export * from "./chapterExam.vue?vue&type=script&lang=js"
import style0 from "./chapterExam.vue?vue&type=style&index=0&id=cf647c08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf647c08",
  null
  
)

export default component.exports